import { NAME as sellerRequestDocumentName } from 'forms/forms/sellerRequest/document/constants';

// FORMS NAMES
import address from './cs/address';
import addTaskVias from './cs/addTaskVias';
import bruttoProduction from './cs/bruttoProduction';
import campaign from './cs/campaign';
import campaignAdditionalData from './cs/campaignAdditionalData';
import campaignManagement from './cs/campaignManagement';
import campaignRegionNomination from './cs/campaignRegionNomination';
import campaigns from './cs/campaigns';
import campaignSettings from './cs/campaignSettings';
import campaignsList from './cs/campaignsList';
import campaignState from './cs/campaignState';
import campaignSubsellerNomination from './cs/campaignSubsellerNomination';
import card from './cs/card';
import clientSearch from './cs/clientSearch';
import common from './cs/common';
import contactDetail from './cs/contactDetail';
import contactHistory from './cs/contactHistory';
import contacts from './cs/contacts';
import contactTake from './cs/contactTake';
import dashboard from './cs/dashboard';
import dashboardCentral from './cs/dashboardCentral';
import dashboardManager from './cs/dashboardManager';
import dashboardPpz from './cs/dashboardPpz';
import dashboardRegion from './cs/dashboardRegion';
import dashboardSeller from './cs/dashboardSeller';
import dateFormats from './cs/dateFormats';
import detail from './cs/detail';
import error from './cs/error';
import fileUpload from './cs/fileUpload';
import guarantors from './cs/guarantors';
import iasErrors from './cs/iasErrors';
import leadDetail from './cs/leadDetail';
import leadTaskHistory from './cs/leadTaskHistory';
import leftMenu from './cs/leftMenu';
import lightBox from './cs/lightBox';
import marketPlace from './cs/marketPlace';
import migrationInProgress from './cs/migrationInProgress';
import modals from './cs/modals';
import nomination from './cs/nomination';
import order from './cs/order';
import organizationStructure from './cs/organizationStructure';
import policyOverview from './cs/policyOverview';
import policySearch from './cs/policySearch';
import printContactDetail from './cs/printContactDetail';
import printNein from './cs/printNein';
import processInformation from './cs/processInformation';
import producedProduction from './cs/producedProduction';
import producedProductionNew from './cs/producedProductionNew';
import producedProductionReport from './cs/producedProductionReport';
import productionControl from './cs/productionControl';
import productionControlDetail from './cs/productionControlDetail';
import pszpNotice from './cs/pszpNotice';
import resolverSettings from './cs/resolverSettings';
import roboAdvisory from './cs/roboAdvisory';
import sellerRequest from './cs/sellerRequest';
import sellerRequestDocumentForm from './cs/sellerRequestDocumentForm';
import semaphore from './cs/semaphore';
import settings from './cs/settings';
import sidebar from './cs/sidebar';
import singleNote from './cs/singleNote';
import site from './cs/site';
import startupCurve from './cs/startupCurve';
import submitFormDialog from './cs/submitFormDialog';
import subordinateUsers from './cs/subordinateUsers';
import subsellerSearch from './cs/subsellerSearch';
import surflyButton from './cs/surflyButton';
import taskCopyEmail from './cs/taskCopyEmail';
import taskCreatingPages from './cs/taskCreatingPages';
import taskDetailPrint from './cs/taskDetailPrint';
import taskFeedback from './cs/taskFeedback';
import taskForwarding from './cs/taskForwarding';
import taskSearch from './cs/taskSearch';
import tasksOverview from './cs/tasksOverview';
import taskStatistics from './cs/taskStatistics';
import templates from './cs/templates';
import tiaPolicies from './cs/tiaPolicies';
import toastr from './cs/toastr';
import tooltips from './cs/tooltips';
import unlockedClients from './cs/unlockedClients';
import userSearch from './cs/userSearch';
import validation from './cs/validation';

const translations = {
	cs: {
		address,
		bruttoProduction,
		card,
		leadDetail,
		leadTaskHistory,
		leftMenu,
		dashboard,
		dashboardCentral,
		dashboardRegion,
		dashboardManager,
		dashboardSeller,
		dashboardPpz,
		campaign,
		campaigns,
		campaignSettings,
		campaignManagement,
		clientSearch,
		common,
		submitFormDialog,
		detail,
		error,
		fileUpload,
		iasErrors,
		policyOverview,
		guarantors,
		sidebar,
		site,
		singleNote,
		startupCurve,
		validation,
		lightBox,
		toastr,
		modals,
		policySearch,
		taskCopyEmail,
		taskDetailPrint,
		taskFeedback,
		taskForwarding,
		tasksOverview,
		tiaPolicies,
		taskSearch,
		subordinateUsers,
		surflyButton,
		campaignsList,
		campaignRegionNomination,
		campaignSubsellerNomination,
		printNein,
		printContactDetail,
		producedProduction,
		producedProductionNew,
		producedProductionReport,
		campaignState,
		taskStatistics,
		contacts,
		contactTake,
		contactDetail,
		contactHistory,
		campaignAdditionalData,
		sellerRequest,
		pszpNotice,
		addTaskVias,
		userSearch,
		tooltips,
		organizationStructure,
		nomination,
		order,
		subsellerSearch,
		templates,
		unlockedClients,
		marketPlace,
		migrationInProgress,
		resolverSettings,
		roboAdvisory,
		semaphore,
		settings,
		productionControl,
		productionControlDetail,
		dateFormats,
		taskCreatingPages,
		processInformation,
		// form
		[sellerRequestDocumentName]: sellerRequestDocumentForm,
	},
};

export default translations;
